<template>
	<div class="brick" style="width:1300px;">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="ship_to_code" ph="Ship To" :showName="false" @set-partner="setPartner" />
				</span>

				<span class="int_type_no_border">
					<SoSelect v-model.trim="so_dn" ph="Enter SO No or Scan" style="width:225px;" @set-invoice="setInvoice" @search="search(true)" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search(true)">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="20px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
					<th width="120px;">Status</th>
					<th width="100px;">S/O No</th>
					<th width="100px;">SO Date</th>
					<th width="90px;">Ship To</th>
					<th width="270px;">Ship To Name</th>
					<th width="80px;">Rack</th>
					<th width="80px;">Section</th>
					<th width="60px;"># of Box</th>
					<th>Memo</th>
					<th width="20px;">+</th>
					<th width="20px;">-</th>
					<th width="80px;">Update</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(m, index) in memos" v-bind:key="index">
					<template v-if="index == 0 || (index > 0 && m.invoice_no != memos[index - 1].invoice_no)">
						<td><input type="checkbox" v-model="m.selected" /></td>
						<td class="al_center">{{ m.status_code | saleStatusName }}</td>
						<td class="al_left">{{ m.so_dn }}</td>
						<td class="al_left">{{ m.so_date }}</td>
						<td class="al_left">{{ m.ship_to_code }}</td>
						<td class="al_left truncate">{{ m.ship_to_name }}</td>
					</template>
					<template v-else>
						<td colspan="6"></td>
					</template>

					<td class="al_left"><input type="text" class="l_int full_int" v-model.trim="m.rack" @focus="$event.target.select()" /></td>
					<td class="al_left"><input type="text" class="l_int full_int" v-model.trim="m.section" @focus="$event.target.select()" /></td>
					<td class="al_left"><currency-input type="text" v-model.trim="m.box_count" :precision="0" class="l_int full_int al_right" @focus="$event.target.select()" /></td>
					<td class="al_left"><input type="text" class="l_int full_int" v-model.trim="m.memo" @focus="$event.target.select()" /></td>
					<td class="al_center"><a href="javascript:;" @click="addMemo(m, index)">+</a></td>
					<td class="al_center">
						<a href="javascript:;" @click="delMemo(m, index, index == 0 || (index > 0 && m.invoice_no != memos[index - 1].invoice_no) ? true : false)">-</a>
					</td>
					<td>
						<template v-if="index == 0 || (index > 0 && m.invoice_no != memos[index - 1].invoice_no)">
							<a v-if="modifiable" href="javascript:;" class="gray_bt2" @click="setMemo(m)">Update</a>
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<!-- <li class="mgr_15">
					<PageSizeSelect v-model="page_size" @input="search()" />
				</li> -->
				<li v-if="modifiable">
					<a href="javascript:;" class="gray_bt" @click="deleteWarehouseMemoBatch()">Clear Info of Selected</a>
					<!-- <router-link class="gray_bt" :to="{ name: 'whReturnDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link> -->
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
//import { apiSoIndex, apiSelectInvoiceList, apiDeleteTempInvoice } from '@/api/sales/invoice.js';
import { apiSelectWarehouseMemoList, apiSetWarehouseMemo, apiDeleteWarehouseMemoBatch } from '@/api/sales/boxing.js';
//import PageSizeSelect from '@/components/common/PageSizeSelect';
import Paging from '@/components/common/Paging';
import PartnerSelect from '@/components/common/PartnerSelect';
import SoSelect from '@/components/common/SoSelect';
//import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
//import CodeSelect from '@/components/common/CodeSelect';
//import PartnerSelect from '@/components/common/PartnerSelect';
//import { today, daysAgo } from '@/utils/date.js';
//import Modal from '@/components/common/Modal';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			ship_to_code: null,
			so_dn: null,

			memos: [],

			allSelected: false,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		Paging,
		//CodeSelect,
		//PageSizeSelect,
		PartnerSelect,
		SoSelect,
	},
	methods: {
		addMemo(m, index) {
			// if (index == this.memos.length - 1) this.memos.push({ invoice_no: m.invoice_no });
			// else if (m.invoice_no != this.memos[index + 1].invoice_no) this.memos.splice(index, 0, { invoice_no: m.invoice_no });

			this.memos.splice(index + 1, 0, { invoice_no: m.invoice_no });
		},
		delMemo(m, index, clear_only) {
			// if (index == this.memos.length - 1) this.memos.push({ invoice_no: m.invoice_no });
			// else if (m.invoice_no != this.memos[index + 1].invoice_no) this.memos.splice(index, 0, { invoice_no: m.invoice_no });
			if (clear_only) {
				m.rack = null;
				m.section = null;
				m.box_count = null;
				m.memo = null;
			} else this.memos.splice(index, 1);
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectMemos(pageNo);
		},
		setPartner(partner) {
			this.ship_to_code = partner.code;

			this.search();
		},
		setInvoice() {
			this.search();
		},
		selectPartner() {
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			this.so_dn = null;
			this.ship_to_code = null;
			this.allSelected = false;
			this.search();
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.memos.forEach(function(memo) {
				memo.selected = vm.allSelected;
			});
		},
		async search() {
			await this.selectMemos();
			//if (this.invoices.length == 1 && this.keyword) this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: this.invoices[0].invoice_no } });
		},
		async selectMemos(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			this.allSelected = false;

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				// sort_key: this.sort_key,
				// sort_direction: this.sort_direction,
				ship_to_code: this.ship_to_code,
				so_dn: this.so_dn,
			};

			const { data } = await apiSelectWarehouseMemoList(param);
			//console.log(data);

			this.memos = data.memoList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			// var uri = '/sales/warehouse_memo?page_no=' + this.page_no;
			// if (this.keyword) uri += '&keyword=' + this.keyword;
			// if (this.status_code) uri += '&status_code=' + this.status_code;
			// if (this.return_type_code) uri += '&return_type_code=' + this.return_type_code;
			// if (this.so_date_from) uri += '&so_date_from=' + this.so_date_from;
			// if (this.so_date_to) uri += '&so_date_to=' + this.so_date_to;
			// if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			// if (this.ship_to_code) uri += '&ship_to_code=' + this.ship_to_code;
			// if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			// if (this.state) uri += '&state=' + this.state;

			// this.uri = uri;
			// window.history.pushState({}, null, uri);
		},
		async setMemo(m) {
			const param = {
				invoice_no: m.invoice_no,
				memos: this.memos.filter(memo => memo.invoice_no == m.invoice_no && (memo.rack || memo.section || memo.box_count || memo.memo)),
			};

			// console.log(param);

			// var dummy = true;
			// if (dummy) return;
			const { data } = await apiSetWarehouseMemo(param);

			if (data.result) {
				this.$toast.success('Updated successfully');
				///this.selectMemos(this.page_no);
			} else {
				this.$toast.error('Failed');
			}
		},
		async deleteWarehouseMemoBatch() {
			if (this.memos.filter(m => m.selected).length == 0) {
				this.$toast.error('Nothing selected.');
				return;
			}

			const { data } = await apiDeleteWarehouseMemoBatch({ invoices: this.memos.filter(m => m.selected) });

			if (data.result) {
				this.$toast.success('Cleared successfully');
				this.selectMemos(this.page_no);
			} else {
				this.$toast.error('Failed');
			}
		},
		async index() {
			//const { data } = await apiSoIndex();
			// this.salesGroups = data.salesGroupList;
			// this.returnTypes = data.returnTypeList;
			//this.states = data.stateList;
		},
		async init() {
			await this.index();
			//this.saleStatusCodes = this.$saleStatusCodes;

			// if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			// if (this.$route.query.status_code) this.status_code = this.$route.query.status_code;
			// if (this.$route.query.return_type_code) this.return_type_code = this.$route.query.return_type_code;
			// if (this.$route.query.so_date_from) {
			// 	if (this.$route.query.so_date_from === 'NON_SELECT') this.so_date_from = null;
			// 	else this.so_date_from = this.$route.query.so_date_from;
			// }

			// if (this.$route.query.so_date_to) {
			// 	if (this.$route.query.so_date_to === 'NON_SELECT') this.so_date_to = null;
			// 	else this.so_date_to = this.$route.query.so_date_to;
			// }

			// if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			// if (this.$route.query.ship_to_code) this.ship_to_code = this.$route.query.ship_to_code;
			// if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
			// if (this.$route.query.state) this.state = this.$route.query.state;

			// await this.selectInvoices(this.$route.query.page_no);

			await this.selectMemos();
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_warehouse_memo');
		this.$store.commit('setSubTitle', 'Sales -> Warehouse Memo');

		//this.selectInvoices();
		this.init();

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style></style>
